module.exports = __webpack_public_path__ + "img/会诊卡.47a36436.png";